import { GridSortModel } from '@mui/x-data-grid-premium'

export const PRODUCT_REGULARITY_HISTORY_CACHE_KEY =
  'product-regularity-history-datagrid'
export const defaultSortModel: GridSortModel = [
  {
    sort: 'asc',
    field: 'aanvoerderNummer',
  },
  {
    sort: 'asc',
    field: 'productCode',
  },
  {
    sort: 'asc',
    field: 'vestigingCode',
  },
]
